// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__UGJZ7","switchBase":"Switch_switchBase__EJF0V","switchTrack":"Switch_switchTrack__zlsWT"};